import { computed, action, runInAction, observable, makeObservable } from "mobx";
import { projectsDataStore } from "Stores/ProjectsStore";
import { userInfoStore } from "Stores/UserInfoStore";
import { API } from "General/API";
import { stringSort } from "utils/defaultSort";
import { ArrayDataStore } from "Stores/RESTStoreInstances/ArrayDataStore";
import { API_URL } from "General/APIEndpoints";
import { CoreStore, handleStoreState } from "Stores/RESTStore/CoreStore";

class TaskGroupStore extends CoreStore {
  data: API_TaskListData[] = [];
  constructor() {
    super();

    makeObservable(this, {
      data: observable,
      listSorted: computed,
      ownTaskGroups: computed,
      globalTaskGroups: computed,
      addList: action.bound,
      deleteList: action.bound,
      editList: action.bound,
      clear: action.bound,
    });

    this.data = [] as ArrayDataStore<API_TaskListData>["data"];
  }

  url() {
    return API_URL.TASKS.getTasklists(projectsDataStore.projectId);
  }

  clear() {
    this.data = [];
  }

  @handleStoreState()
  async fetch() {
    try {
      const response = await API.getData<API_TaskListData[]>(this.url());
      this.data = response;
    } catch (error) {
      throw error;
    }
  }

  async addList(values: API_TaskListData) {
    try {
      const response = await API.newData(this.url(), { ...values, ownerId: +userInfoStore.id });
      runInAction(() => {
        this.data.push(response);
      });
    } catch (err) {
      throw err;
    }
  }

  async deleteList(id: number) {
    try {
      await API.deleteData(API_URL.TASKS.deleteTasklist(projectsDataStore.projectId, id));
      this.fetch();
    } catch (err) {
      throw err;
    }
  }

  async editList(id: number, name: string, description: string) {
    try {
      const idx = this.data.findIndex((item) => item.id === id);
      const listToEdit = this.data[idx];
      const body = { name, description, global: listToEdit.global };
      await API.editData(API_URL.TASKS.updateTasklist(projectsDataStore.projectId, id), body);
      this.fetch();
    } catch (err) {
      throw err;
    }
  }

  findList(id: number) {
    return this.data.find((item) => item.id === id);
  }

  getName(id: number) {
    return this.data.find((item) => item.id === id)?.name;
  }

  get listSorted() {
    return this.data.slice().sort((a, b) => stringSort<API_TaskListData>(a, b, "name"));
  }

  get ownTaskGroups() {
    return this.listSorted.filter((item) => item.global === false);
  }

  get globalTaskGroups() {
    return this.listSorted.filter((item) => item.global === true);
  }
}

const taskGroupStore = new TaskGroupStore();

export { taskGroupStore, TaskGroupStore };
